<template>
	<div class="pages">
		<router-link :to="{ name: 'Home' }" tag="span" class="logo">
			<img src="../../../static/images/logo.png" alt="" class="logo-img">
		</router-link>

		<div class="box">
			<div class="box-tit">{{ $t('登录') }}</div>
			<div class="box-box">
				<div class="box-ipt">
					<div class="ipt-tit">{{ $t('手机号') }}</div>
					<div class="ipt-ipt">
						<el-dropdown @command="prefixHandleCommand">
							<span class="el-dropdown-link">
								+{{ prefix }}<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :command="item.name" v-for="(item, index) in prefix_list"
									:key="index">
									{{ item.name }}
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<input type="number" :placeholder="$t('请输入您的手机号')" v-model="mobile">
					</div>
				</div>
				<div class="box-ipt">
					<div class="ipt-tit">{{ $t('密码') }}</div>
					<div class="ipt-ipt">
						<input :type="input_type" :placeholder="$t('请输入您的密码')" v-model="password">
						<img src="../../../static/images/icon/icon03.png" alt="" v-if="input_type == 'password'"
							@click="input_type = 'text'">
						<img src="../../../static/images/icon/icon02.png" alt="" v-else
							@click="input_type = 'password'">
					</div>
				</div>
				<div class="flex align-center justify-between text-14 margin-top-24">
					<router-link :to="{ name: 'Register' }">{{ $t('注册账号') }}</router-link>
					<router-link :to="{ name: 'changePassword' }">{{ $t('忘记密码') }}</router-link>
				</div>
				<div class="box-btn pointer" @click="onLogin">{{ $t('登录') }}</div>
				<div class="flex justify-center margin-top-32">
					<el-radio-group v-model="language" @change="handleCommand">
						<el-radio label="zh_CN">中文</el-radio>
						<el-radio label="en_US">English</el-radio>
					</el-radio-group>
				</div>
				<div class="box-read" style="margin-top: 48px;">
					<el-checkbox v-model="is_read">
						<div style="color: #333;">
							{{ $t('我已阅读并同意') }}
							<span class="text-61AC85" @click.stop="onPage(14)">{{ $t('《用户协议》') }}</span>
							{{ $t('与') }}
							<span class="text-61AC85" @click.stop="onPage(13)">{{ $t('《隐私政策》') }}</span>
						</div>
					</el-checkbox>
				</div>
			</div>
		</div>

		<div class="pop" v-if="is_pop">
			<div class="pop-box">
				<div class="pop-box-top">
					<img src="" class="top-img">
					<div class="top-tit">{{ $t('用户协议') }}</div>
					<img src="../../assets/login/icons/icon01.png" class="top-img" style="cursor: pointer;"
						@click="is_pop = false">
				</div>
				<div class="pop-box-txt">
					<div v-html="content" class="detail-html"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import { validUsername } from '@/utils/validate';
import AppFooter from '@/components/AppFooter';
import CaptchaFetch from '@/components/CaptchaFetch';
import { login, userInfo } from '@/api/login';
import { systemPage, phonePrefix, getconf } from '@/api/user';
import { Language } from "@/utils/auth";
import he from 'he';

export default {
	name: 'Login',
	components: {
		'app-footer': AppFooter,
		'captcha-fetch': CaptchaFetch
	},
	data() {
		return {
			mobile: '',//手机号
			password: '',//密码
			input_type: 'password',//输入框type
			language: 'zh_CN',//语言
			is_read: true,//是否勾选用户协议隐私政策
			is_pop: false,//弹窗
			content: '',//富文本
			prefix_list: [],//前缀列表
			prefix: '',//前缀
			app_logo: '',//logo
		}
	},
	mounted() {
		this.onPhonePrefix();
		this.onGetconf()
		this.language = Language() || this.$i18n.locale || 'zh_CN'
	},
	methods: {
		onGetconf() {
			getconf({ module: 'app' }).then(res => {
				if (res.code == 1) {
					let data = res.data
					this.app_logo = data.app_logo
				}
			})
		},
		/**前缀切换 */
		prefixHandleCommand(e) {
			// console.log(e);
			this.prefix = e
		},
		/**手机号前缀 */
		onPhonePrefix() {
			phonePrefix().then(res => {
				this.prefix_list = res.data
				this.prefix = this.prefix_list[0].name
			})
		},
		// 语言切换
		handleCommand(e) {
			if (!e || e === Language()) return
			this.$cookies.set('locale', e, { expires: 7 }); // 7天后过期
			this.$i18n.locale = e;
			window.location.reload();
		},
		//1用户协议2隐私政策
		onPage(i) {
			systemPage({ type: i }).then(res => {
				this.content = he.decode(res.data.content)
				this.is_pop = true
				// console.log(this.content);
			})
		},
		/**登录 */
		onLogin() {
			if (!this.mobile) {
				this.$message(this.$t('请输入手机号'));
				return
			}
			if (!this.password) {
				this.$message(this.$t('请输入密码'));
				return
			}
			if (!this.is_read) {
				this.$message(this.$t('请阅读并同意遵守《用户协议》'));
				return
			}

			let data = {
				mobile: this.mobile,
				password: this.password,
				prefix: this.prefix
			}
			login(data).then(res => {
				if (res.code == 1) {
					// console.log(res);
					this.$cookies.set('user_token', res.data.userinfo.user_token, { expires: 7 }); // 7天后过期
					this.onUserInfo()
				} else {
					this.$message.warning(res.msg);
				}
			})
		},
		/**用户信息 */
		onUserInfo() {
			userInfo().then(res => {
				console.log(res);
				if (res.code == 1) {
					this.$message.success(this.$t('登录成功'));
					this.$cookies.set('user_info', JSON.stringify(res.data), { expires: 7 }); // 7天后过期

					setTimeout(() => {
						this.$router.push({ name: 'Home' });
					}, 1000)
				}
			})
		},
		//区域选择
		// handleCommand(command) {
		// 	// this.$message('click on item ' + command);
		// 	console.log(command);
		// },
		//切换登录、注册、忘记密码
		onCut(i) {
			console.log(i)
			this.is_register = false
			this.is_change_password = false
			this.is_login = false
			if (i == 1) {
				this.is_change_password = true
			} else if (i == 2) {
				this.is_register = true
			} else {
				this.is_login = true
			}
		},
		//标签页点击
		handleClick(tab, event) {
			console.log(tab, event);
		},
	},
};
</script>

<style scoped lang="scss">
.pages {
	padding-top: 24px;
	min-height: 100vh;
	height: auto;
	background: url('../../../static/images/bg/bg01.png') no-repeat;
	background-size: cover;
	background-position: center;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-left: 16px;
	padding-right: 16px;
}

.logo {
	display: flex;
	justify-content: center;
	padding-bottom: 64px;

	.logo-img {
		width: 160px;
		height: 85px;
		cursor: pointer;
	}
}

.box {
	display: flex;
	flex-direction: column;
	align-items: center;
	background: #FFFFFF;
	box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);
	border-radius: 8px;
	padding: 32px 20px;
	width: 100%;
	max-width: 780px;

	@media (min-width: 768px) {
		padding: 60px 100px;
	}

	.box-tit {
		font-size: 36px;
		color: #333333;
		font-weight: 500;
		margin-bottom: 16px;
	}

	.box-box {
		width: 100%;
		max-width: 580px;

		/**语言选择器选中状态统一为黑色 */
		/deep/ .el-radio__input.is-checked .el-radio__inner {
			border-color: #000000;
			background: #000000;
		}

		/deep/ .el-radio__input.is-checked + .el-radio__label {
			color: #000000;
		}

		/**用户协议复选框选中状态统一为黑色 */
		/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
			border-color: #000000;
			background: #000000;
		}

		/**输入框 */
		.box-ipt {
			width: 100%;
			border-bottom: 1px solid #666666;
			margin-top: 24px;

			.ipt-tit {
				font-size: 16px;
			}

			.ipt-ipt {
				padding: 16px 0;
				display: flex;
				align-items: center;
				justify-content: space-between;

				input {
					font-size: 16px;
					width: calc(100% - 50px);
				}

				img {
					width: 24px;
					height: 24px;
					cursor: pointer;
				}
			}
		}

		/**按钮 */
		.box-btn {
			width: 100%;
			height: 56px;
			margin-top: 48px;
			background: #FFFFFF;
			border-radius: 4px;
			border: 1px solid #000000;
			font-size: 20px;
			color: #000000;
			line-height: 56px;
			text-align: center;
		}

		/**用户协议或隐私政策 */
		.box-read {
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			color: #333333;
			margin-top: 12px;
			cursor: pointer;

			/**H5 端协议文本与复选框对齐，英文长文案可正常换行 */
			@media (max-width: 767px) {
				justify-content: flex-start;

				/deep/ .el-checkbox {
					display: flex;
					align-items: flex-start;
					text-align: left;
				}

				/deep/ .el-checkbox__input {
					flex-shrink: 0;
					margin-top: 2px;
				}

				/deep/ .el-checkbox__label {
					flex: 1;
					min-width: 0;
					white-space: normal;
					line-height: 20px;
				}
			}
		}
	}
}

/**弹窗 */
.pop {
	width: 100vw;
	height: 100vh;
	background-color: rgba(50, 50, 50, 0.8);
	position: fixed;
	left: 0;
	top: 0;
	z-index: 999;
	display: flex;
	align-items: center;
	justify-content: center;

	.pop-box {
		width: 92vw;
		max-width: 1200px;
		/* // height: 732px; */
		max-height: 732px;
		background: #FFFFFF;
		border-radius: 16px;
		padding-bottom: 32px;

		.pop-box-top {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 90px;
			padding: 0 24px;

			.top-img {
				width: 16px;
				height: 16px;
			}

			.top-tit {
				font-size: 20px;
				font-weight: bold;
				color: #333333;
			}
		}

		.pop-box-txt {
			padding: 0 48px;
			font-size: 16px;
			color: #333333;
			/* // height: 609px; */
			max-height: 610px;
			overflow-y: auto;
			box-sizing: border-box;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/view/login/Login.vue